import {
  createAggregateRoot,
  IAggregateRoot,
  NizzaEventStatus,
  NizzaTimeZone,
} from '@nizza/core';
import {
  EventCollection,
  EventConfig,
  EventInfo,
  EventMediaConvertData,
  EventStreamData,
  NizzaEventProps,
  RawNizzaEvent,
} from './types';

export class NizzaEvent implements IAggregateRoot, NizzaEventProps {
  readonly root = createAggregateRoot<NizzaEventProps, NizzaEvent>(this);

  id!: string;
  eventName!: string;
  utm!: string;
  status!: NizzaEventStatus;
  created!: Date;
  collection!: EventCollection;
  streamData!: EventStreamData;
  info!: EventInfo;
  config!: EventConfig;
  workspace!: string;
  mediaConvert!: EventMediaConvertData;
  timeZone!: NizzaTimeZone;
  eventCategory!: string;
  eventDateTime!: string;

  constructor(props: NizzaEventProps) {
    this.root.setProps(props);
  }

  static toDomain(raw: RawNizzaEvent): NizzaEvent {
    const { createdAt, ...rest } = raw;

    const data: NizzaEventProps = {
      ...rest,
      created: new Date(Number(createdAt)),
    };

    return new NizzaEvent(data);
  }

  toPrimitives() {
    const { root, created, ...rest } = this;
    return {
      ...rest,
      createdAt: created.getTime(),
    };
  }
}
